export default __webpack_public_path__ + "images/6aaf4a36e35b1b71bc077e200ac7429c-1_tablet_1067x470.jpg";